import {
	InputField,
} from "~/components/Forms";

function CustomerSearchBar({filter, onSearchChange})
{
	const handleKeywordChange = (e) =>
    {
		if (!onSearchChange) return;
		const newFilter = {
			...filter,
			keyword: e.target.value,
			page: 1,
		};
		onSearchChange(newFilter);
	}

	return (
		<div className="search-bar pt-0 pb-2">
			<div className="container">
				<form className="form p-0" autoComplete="off">
					<InputField name="keyword" placeholder="Tên, code, email, số điện thoại khách hàng" onChange={handleKeywordChange} />
				</form>
			</div>
		</div>
	)
}

export default CustomerSearchBar;